import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as NotificationsActions from './notifications.actions';
import { NotificationsPageParams } from './notifications.model';
import * as NotificationsSelectors from './notifications.selectors';

@Injectable()
export class NotificationsFacade {
    private readonly store = inject(Store);

    readonly notificationsList$ = this.store.select(NotificationsSelectors.selectNotificationsList);
    readonly pageParams$ = this.store.select(NotificationsSelectors.selectPageParams);
    readonly loading$ = this.store.select(NotificationsSelectors.selectLoading);
    readonly loaded$ = this.store.select(NotificationsSelectors.selectLoaded);
    readonly loadError$ = this.store.select(NotificationsSelectors.selectLoadError);
    readonly totalElements$ = this.store.select(NotificationsSelectors.selectTotalElements);
    readonly notificationIdsInProgress$ = this.store.select(NotificationsSelectors.selectNotificationIdsInProgress);
    readonly unreadCount$ = this.store.select(NotificationsSelectors.selectUnreadCount);
    readonly unreadCountLoading$ = this.store.select(NotificationsSelectors.selectUnreadCountLoading);

    loadNotifications(pageParams: NotificationsPageParams = {}): void {
        this.store.dispatch(NotificationsActions.loadNotificationsList({ pageParams }));
    }

    makeRead(id: number): void {
        this.store.dispatch(NotificationsActions.makeNotificationRead({ id }));
    }

    setPageParams(pageParams: NotificationsPageParams): void {
        this.store.dispatch(NotificationsActions.setPageParams({ pageParams }));
    }

    loadUnreadCount(): void {
        this.store.dispatch(NotificationsActions.loadUnreadCount());
    }

    startUnreadCountPolling(): void {
        this.store.dispatch(NotificationsActions.startUnreadCountPolling());
    }
}
